(ns practitest.frontend.milestone.translations
  [:require [practitest.frontend.common.i18n :as i18n]])

(def t
  (i18n/translation-fn
   {"milestones.linked.delete-confirmation"
    "Note: The value you selected is used in multiple entities ( Dashboards/ filters etc.). Deleting it will remove it from all of them, leaving empty fields."
    "milestones.want-to-proceed" "Do you want to proceed?"
    "milestones.value-to-delete" "Value to delete: "
    "milestones.delete-confirmation" "Milestone %{milestone} will be deleted permanently. Do you want to proceed?"
    "milestone.delete-confirmation.title" "Delete Milestone?"
    "milestone.last-update" "Last Updated: %{last-update}"
    "milestone.period" "From: %{from} to: %{to}"
    "milestone.notify.archived" "Milestone was successfully archived"
    "milestone.notify.unarchived" "Milestone was successfully unarchived"
    "milestone.readiness-index.metric.coverage-confidence" "Coverage Confidence"
    "milestone.readiness-index.metric.execution-confidence" "Execution Confidence"
    "milestone.readiness-index.metric.remaining-defects-risk" "Remaining Defects Risk"
    "milestone.readiness-index.badge.not-calculated.text" "Score is not calculated"
    "milestone.readiness-index.badge.not-calculated.tooltip" "Release Readiness was not calculated for milestones completed before the feature was enabled."
    "milestone.readiness-index.badge.needs-attention" "Needs Attention"
    "milestone.readiness-index.badge.on-track" "On Track"
    "milestone.readiness-index.badge.off-track" "Off Track"
    "milestone.readiness-index.badge.ready" "Ready"
    "generic.button.delete" "Delete"
    "generic.button.cancel" "Cancel"}))



